import * as React from 'react';
import Slider from 'react-slick';

import Hero from './blocks/hero';
import PageList from './blocks/pageList';
import Columns from './blocks/columns';
import TabsItems from './blocks/tabsItems';
import TabsAccordion from './blocks/tabsAccordion';
import Accordion from './blocks/Accordion';
import Image from './blocks/image';
import ProductList from './blocks/productList';
import Links from './blocks/links';
import ItemList from './blocks/items';
import Alert from './blocks/alert';
import ProductPageSetTile from './blocks/productPageSetTile';
import PromoForm from './blocks/promoForm';

import { classNames, getHardcodedPathByLocaleCode } from '../utils';

const BlockComponent = ({ block, currentLocaleCode }) => {
  const isBrowser = typeof window !== 'undefined';
  const [isMobile] = React.useState(isBrowser ? window.innerWidth < 768 : false);
  const currentHomePage = getHardcodedPathByLocaleCode('home', currentLocaleCode);

  const isHomePage =
    typeof window !== 'undefined' ? window.location.pathname === currentHomePage : false;
  const homepageSettings = {
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 2,
    infinite: false,
    arrows: !isMobile,
    dotsClass: 'slick-dots slider-dots',
    appendDots: (dots) => <ul className="slider-dots slick-dots"> {dots} </ul>,
    dots: true,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: isHomePage ? 5 : 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1080,
        settings: {
          slidesToShow: isHomePage ? 5 : 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  };
  const settings = {
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 2,
    infinite: false,
    arrows: !isMobile,
    dotsClass: 'slick-dots slider-dots',
    appendDots: (dots) => <ul className="slider-dots slick-dots"> {dots} </ul>,
    dots: true,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: isHomePage ? 5 : 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1080,
        settings: {
          slidesToShow: isHomePage ? 5 : 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 2,
          dots: true,
        },
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: true,
        },
      },
    ],
  };
  return (
    <>
      {Object.keys(block).map((key, index) => {
        const value = block[key];
        if (value) {
          switch (key) {
            case 'alert':
              return <Alert key={`${key}-${index}`} data={value} />;
            case 'hero':
              return <Hero key={`${key}-${index}`} data={value} />;
            case 'page_list':
              return <PageList key={`${key}-${index}`} data={value} />;
            case 'links':
              return <Links key={`${key}-${index}`} data={value} />;
            case 'product_list':
              return <ProductList key={`${key}-${index}`} data={value} />;
            case 'columns':
              return <Columns key={`${key}-${index}`} data={value} />;
            case 'tabs_items':
              return (
                <>
                  <TabsItems tabs={value} />
                  <TabsAccordion tabs={value} />
                </>
              );
            case 'accordion':
              return <Accordion key={`${key}-${index}`} {...value} />;
            case 'item_list':
              return <ItemList key={`${key}-${index}`} data={value} />;
            case 'image':
              return <Image key={`${key}-${index}`} data={value} />;
            case 'promo_form':
              return <PromoForm key={`${key}-${index}`} data={value} />;
            case 'content_block':
              return (
                <div key={`${key}-${index}`} className="col-span-12 content">
                  <div className="mx-auto">
                    <div className={classNames('content-block', value.attributes.class)}>
                      {value.title && <h2 className="title">{value.title}</h2>}
                      <div
                        className="inner-content"
                        dangerouslySetInnerHTML={{ __html: value.content }}
                      />
                    </div>
                  </div>
                </div>
              );
            case 'product_set_page_list':
              if (isHomePage) {
                return (
                  <div key={`${key}-${index}`} className="col-span-12 slider">
                    <h2>{value.title}</h2>

                    <Slider {...homepageSettings}>
                      {value.product_set_pages.map((related_product) => {
                        return (
                          <ProductPageSetTile
                            key={related_product.title}
                            product={related_product}
                            linkTextCard={value?.cta_title}
                          />
                        );
                      })}
                    </Slider>
                  </div>
                );
              } else {
                return (
                  <div key={`${key}-${index}`} className="col-span-12 slider">
                    <h2>{value.title}</h2>

                    <Slider {...settings}>
                      {value.product_set_pages.map((related_product) => {
                        return (
                          <ProductPageSetTile
                            key={related_product.title}
                            product={related_product}
                            linkTextCard={value?.cta_title}
                          />
                        );
                      })}
                    </Slider>
                  </div>
                );
              }
            default:
              return (
                <span>
                  {key} - {JSON.stringify(value)}
                </span>
              );
          }
        }
        return null;

        // const value = block[key];
        // if (value) {
        //   switch (key) {
        //     case "custom_html":
        //       return <div dangerouslySetInnerHTML={{ __html: value }} />;
        //     case "product_list":
        //       return <div>{value}</div>;
        //     case "columns":
        //       return <div>{value}</div>;
        //     default:
        //       return <div>{key}</div>;
        //   }
        // }
      })}
    </>
  );
};
export default BlockComponent;
